import $ from 'jquery';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
export default (function () {
  // Dropdown Menu in Desktop View
  $('#skip-links').on('click', function (e) {
    e.preventDefault();

    switch (e.target.id) {
      case 'skip-links-nav-main':
        if (!window.matchMedia('(max-width: 992px)').matches) {
          if ($('.site-navigation-level-1').length > 0) {
            $('.site-navigation-level-1 a:first').attr('tabindex', '0').focus().addClass('focus-visible');
          } else {
            $('.nav-top-menu a:first').attr('tabindex', '0').focus().addClass('focus-visible');
          }
        } else {
          $('[data-target=".navbar-control"]').attr('tabindex', '0').focus().addClass('focus-visible');
        }

        break;

      case 'skip-links-main':
        $('html, body').animate({
          scrollTop: $('.hero').offset().top
        }, 700);
        $('[data-ct-component="hero"] :header').first().attr('tabindex', '0').focus();
        break;

      default:
        $('html, body').animate({
          scrollTop: $('#footer-row').offset().top - 75
        }, 700);
        $('#footer-row').attr('tabindex', '-1').focus();
        break;
    }
  });
  $('.site-navigation-level-2 .dropdown').on({
    'shown.bs.dropdown': function shownBsDropdown(e) {
      var link = e.relatedTarget;
      var menu = link.nextElementSibling;
      var linkRect = link.getBoundingClientRect();
      var menuRect = menu.getBoundingClientRect();
      var docWidth = document.documentElement.offsetWidth;
      var fitsLeft = linkRect.right - menuRect.width >= 0;
      var fitsRight = menuRect.right <= docWidth;
      var ctComponent = $(link).closest('[data-ct-component]');
      var componentName = ctComponent.attr('data-ct-component');
      ctComponent.attr('data-ct-component', componentName.replace('-open', ''));

      var menuPos = function menuPos(w) {
        var mar = (docWidth - w) / 2;
        if (mar >= 0) return mar;
        return 0;
      };

      if (fitsRight) {
        return false;
      }

      if (fitsLeft && !fitsRight) {
        menu.classList.add('dropdown-menu-right');
      } else {
        menu.style.position = 'fixed';
        menu.style.top = "".concat(menuRect.top, "px");
        menu.style.right = "".concat(menuPos(menuRect.width), "px");
        menu.style.left = "".concat(menuPos(menuRect.width), "px");
      }
    },
    'hidden.bs.dropdown': function hiddenBsDropdown(e) {
      var $this = $(e.relatedTarget);
      var $menu = $this.next('.dropdown-menu');
      var ctComponent = $this.closest('[data-ct-component]');
      var componentName = ctComponent.attr('data-ct-component');

      if (!componentName.endsWith('-open')) {
        ctComponent.attr('data-ct-component', "".concat(componentName, "-open"));
      }

      $menu.removeAttr('style');
      $menu.removeClass('dropdown-menu-right');
    }
  });
  $('[data-toggle="slide"]').on('click', function (e) {
    e.preventDefault();
    var $this = $(e.target);
    var targetEle = $this.data('target');
    var $target = $(targetEle);
    $target.toggleClass('open');
    $('html').toggleClass('overflow-hidden');
  });

  function addActiveClassSection(section, item) {
    if ($("[data-nav-".concat(section, "='").concat(item, "']")).length > 0) {
      var el = $("[data-nav-".concat(section, "='").concat(item, "']"));
      var addClass = $(el).hasClass('active') ? null : 'active';
      $(el).addClass(addClass);
    }
  }

  function addActiveClassSubsection(item, section) {
    if (item.length > 0 && !item.includes('index') && $('.header-meganav') && $("[data-nav-subsection='".concat(item, "']")).length > 0) {
      var lvl1 = $("[data-nav-section='".concat(section, "']"));
      $(lvl1).find('[data-nav-subsection], .tab-pane').removeClass('active', 'show');
      var tabLeft = $(lvl1).find($("[data-nav-subsection*='".concat(item, "']")));
      var addClass = $(tabLeft).hasClass('active') ? null : 'active';
      $(tabLeft).addClass(addClass);
      var labelledBy = $(tabLeft).attr('id');
      var tabRight = $("[aria-labelledby='".concat(labelledBy, "']"));
      var addClass1 = $(tabRight).hasClass('active') ? null : 'active';
      var addClass2 = $(tabRight).hasClass('show') ? null : 'show';
      $(tabRight).addClass(addClass1).addClass(addClass2);
    }
  }

  function setAccordionActive(item) {
    var accordionRow = $("[data-nav-accordion-section='".concat(item, "']")).children();
    $(accordionRow[0]).attr('aria-expanded', true);
    $($(accordionRow[0]).children()[0]).removeClass('right').addClass('down');
    $(accordionRow[1]).addClass('show');
  }

  function showLevel2Nav(item) {
    $('.site-navigation-level-2').each(function (index) {
      if ($($('.site-navigation-level-2')[index]).attr('data-nav-level2') === item) {
        $($('.site-navigation-level-2')[index]).removeClass('d-none');
      }
    });
  }

  function setActive() {
    // get path Array for untagged pages (cigna.com support)
    var pathArray = window.location.pathname.split('/');
    var section = pathArray[1] === 'es-us' ? pathArray[2] : pathArray[1];
    var subsection = pathArray[1] === 'es-us' ? pathArray[3] : pathArray[2]; // add active for flex-header nav-level using meta tag

    var metaSec = $('meta[name=section]').attr('content');
    var metaSubSec = $('meta[name=subsection]').attr('content');
    var isMeganav = $('.header-meganav').length > 0;

    if (metaSec) {
      setAccordionActive(metaSec);
      addActiveClassSection('section', metaSec);
      showLevel2Nav(metaSec);

      if (metaSubSec) {
        if (isMeganav) {
          addActiveClassSubsection(metaSubSec, metaSec);
        } else {
          addActiveClassSection('subsection', metaSubSec);
        }
      } // extends logic to pages without tags (support for old navigation)

    } else {
      if (section && section.length > 0) {
        addActiveClassSection('section', section.replace('.html', ''));
      }

      setAccordionActive(section.replace('.html', ''));
      showLevel2Nav(section.replace('.html', ''));

      if (subsection && subsection.length > 0) {
        if (isMeganav) {
          addActiveClassSubsection(subsection.replace('.html', ''), section);
        } else {
          addActiveClassSection('subsection', subsection.replace('.html', ''));
        }
      }
    }
  }

  if ($('[data-nav-section]').length) {
    setActive();
  }
});